import { createAction } from '@sde/widgets-core/src/redux/helpers/createAction';
import { SET_PRINTING } from './constants';

export const setPrinting = (data) => {
  return createAction({
    type: SET_PRINTING,
    action: data,
  });
};
